import { Box, Chip } from "@mui/material";
import React from "react";

// Utility to render chips from a comma-separated string
export const renderChips = (field: string) => {
  const ChipsRenderer = (row: any) => {
    const values = (row[field] || "")
      .split(",")
      .map((val: string) => val.trim())
      .filter(Boolean);

    return (
      <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
        {values.map((val: string, idx: number) => (
          <Chip key={idx} label={val} size="small" />
        ))}
      </Box>
    );
  };
  ChipsRenderer.displayName = `RenderChips_${field}`;
  return ChipsRenderer;
};